import { configureStore, combineReducers } from '@reduxjs/toolkit';
import headerReducer from '../features/common/headerSlice';
import modalReducer from '../features/common/modalSlice';
import rightDrawerReducer from '../features/common/rightDrawerSlice';
import leadReducer from '../features/leads/leadSlice';
import userReducer from '../features/user/userSlice';

import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
};

const rootReducer = combineReducers({
  user: userReducer,
  header: headerReducer,
  rightDrawer: rightDrawerReducer,
  modal: modalReducer,
  lead: leadReducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
});

let persistor = persistStore(store);

export { store, persistor };